var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00C4B3;}\r\n\t.st1{fill:#22D3C5;}\r\n\t.st2{fill:#0075C9;}\r\n\t.st3{fill:#00A8E1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.8,33.6l-3.2-3.2v23.3v1.1c0,0.5,0.1,1.1,0.2,1.7l25.5,9l6.4-2.8l0,0L53.8,33.6L53.8,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.9,56.5L50.9,56.5L50.9,56.5L50.9,56.5z M82.9,62.6l-6.4,2.8l-25.5-9c0.5,1.8,1.6,3.9,2.7,5.2L62,70h18.5 L82.9,62.6L82.9,62.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.6,30.4l-9.9,15c-0.9,0.9-0.4,2.7,0.9,4l5.8,5.8l3.6,1.2c-0.1-0.6-0.2-1.2-0.2-1.7v-1.1L50.6,30.4 L50.6,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.6,30.6c-0.6-0.1-1.2-0.2-1.7-0.2h-1.1H50.6l32.2,32.2l2.8-6.4L76.6,30.6L76.6,30.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.6,30.6L76.6,30.6L76.6,30.6L76.6,30.6z M81.8,33.5c-1.2-1.2-3.3-2.2-5.2-2.7l9.1,25.5l-2.8,6.4l6.9-2.2 v-19L81.8,33.5L81.8,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.4,27.1l-5.8-5.8c-1.3-1.3-3.2-1.7-4-0.9l-15,9.9h23.2h1.1c0.5,0,1.1,0.1,1.7,0.2L75.4,27.1L75.4,27.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/Dart.1e3facc7969e0292385ceffae0cb50dc.svg";
export { ForwardRef as ReactComponent };